import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postAssetsCategory({ body }) {
  return BaseService.post(REST.ASSETS_CATEGORY, body);
}

function putAssetsCategory({ body, id }) {
  return BaseService.put(REST.ASSETS_CATEGORY_ID(id), body);
}

function getAssetsCategory(params) {
  return BaseService.get(REST.ASSETS_CATEGORY, {
    params: paramsFilter({ params }),
  });
}

function deleteAssetsCategory({ id }) {
  return BaseService.delete(REST.ASSETS_CATEGORY_ID(id));
}

export default {
  getAssetsCategory,
  postAssetsCategory,
  putAssetsCategory,
  deleteAssetsCategory,
};
